import styled from "@emotion/styled";

export const StyledFormContainer = styled("div")`
  display: flex;
  gap: 20px;
  align-items: flex-start;
`;

export const StyledEditorColumn = styled("div")`
  flex: 3;
`;

export const StyledFieldsColumn = styled("div")`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
